export const localApiURL = process.env.REACT_APP_API_URL;

export const GetAPIURL = () => {
    return localApiURL;
};